import { render, staticRenderFns } from "./SchoolWebsite.vue?vue&type=template&id=f99016b6"
import script from "./SchoolWebsite.vue?vue&type=script&lang=js"
export * from "./SchoolWebsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports